export default "__VITE_ASSET__6786a9ac__"